var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6198 3.95899C14.5342 2.58659 13.394 1.5 12 1.5C10.5503 1.5 9.375 2.67525 9.375 4.125V4.65439C6.95104 5.67853 5.25 8.07809 5.25 10.875V15.438L3.96967 16.7197C3.82902 16.8603 3.75 17.0511 3.75 17.25V19.125C3.75 19.5392 4.08579 19.875 4.5 19.875H9V21L9.00687 21.1445C9.07955 21.9051 9.7203 22.5 10.5 22.5H13.5L13.6445 22.4931C14.4051 22.4204 15 21.7797 15 21V19.875H19.5C19.9142 19.875 20.25 19.5392 20.25 19.125V17.25L20.2407 17.132C20.2159 16.9768 20.1429 16.8322 20.0303 16.7197L18.75 15.439V10.875C18.75 8.07809 17.049 5.67853 14.625 4.65439V4.125L14.6198 3.95899ZM13.125 4.21829V4.125C13.125 3.50368 12.6213 3 12 3C11.4201 3 10.9427 3.43876 10.8816 4.00242L10.875 4.125V4.21829C11.1652 4.16961 11.4616 4.13944 11.763 4.12904L12 4.12496C12.3833 4.12496 12.7591 4.15691 13.125 4.21829ZM10.5 21V19.875H13.5V21H10.5ZM17.25 10.875C17.25 7.97546 14.8995 5.62496 12 5.62496C9.1005 5.62496 6.75 7.97546 6.75 10.875V15.75C6.75 15.9489 6.67098 16.1397 6.53033 16.2803L5.25 17.56V18.374H18.75V17.561L17.4697 16.2803C17.3571 16.1678 17.2841 16.0232 17.2593 15.868L17.25 15.75V10.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.de8138fe308941ff9ac979323cdcb2ad.svg";
export { ForwardRef as ReactComponent };